import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { AcceptInputComponent } from './accept-input.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    AcceptInputComponent
  ],
  exports: [
    AcceptInputComponent
  ]
})
export class AcceptInputModule {}
